import { BaseController } from "../../common/base/controller";

export class FinishController extends BaseController {
	constructor(
		$scope,
		$q,
		controllerService,
		uiModalDeclarationService,
		finishService,
		configService,
	) {
		"ngInject";
		super({
			$scope,
			$q,
			controllerService,
			uiModalDeclarationService,
			finishService,
			configService,
		});

		this.steps = [
			{
				title: "shipmentOfChange",
			},
			{
				title: "durationOfChange",
			},
			{
				title: "duplicationPrevention",
			},
		];
	}

	steps = [];

	loadTime = 3000;
	loadPromise;
	percentProgress = 0;

	get api() {
		return this.appConfig.get().api.path;
	}

	get applicationPageRedirectUrl() {
		return (
			this.investmentApplicationRedirect || this.portfolioApplicationRedirect
		);
	}

	$onInit() {
		// eslint-disable-next-line angular/window-service
		window.scrollTo(0, 0);

		this.documentId = this.appCache.get("documentId");
		this.documentToken = this.appCache.get("documentToken");
		if (this.showOtherFinish) {
			this.shipmentStarted = this.appCache.get("shipmentStarted");
		}

		this.investmentApplicationRedirect = this.appCache.get(
			"investmentApplicationRedirect",
		);
		this.portfolioApplicationRedirect = this.appCache.get(
			"portfolioApplicationRedirect",
		);

		if (this.applicationPageRedirectUrl) {
			this.redirectLinkMessage = this.investmentApplicationRedirect
				? "app.finish.redirectLinkText.investment"
				: "app.finish.redirectLinkText.portfolio";
			this.redirectText = this.investmentApplicationRedirect
				? "app.finish.redirectText.investment"
				: "app.finish.redirectText.portfolio";
		}

		this.abdicationCancellationRight = this.appCache.get(
			"abdicationCancellationRight",
		);

		this.rating = 0;
		this.message = null;
		this.pdfDownloaded = false;

		this.setBeforeUnloadEvent();
		if (this.finishService.isAsyncProccessingActive) {
			this.awaitDocuments();
		}
	}

	get orderId() {
		return this.appCache.get("orderId");
	}

	get jwt() {
		return this.appCache.get("jwt");
	}

	awaitDocuments() {
		this.finishService
			.askForDocuments(this.orderId, this.jwt)
			.then((res) => {
				const { documentId, documentToken } = res.data;

				if (documentId) {
					this.appCache.set("documentId", documentId);
					this.appCache.set("documentToken", documentId);
					this.documentId = documentId;
					this.documentToken = documentToken;
				} else {
					this.nextLoad();
				}
			})
			.catch((res) => {
				if (this.percentProgress < 80) {
					this.percentProgress += 20;
				}
				this.nextLoad();
			});
	}

	get documentIsPresent() {
		return this.appCache.get("documentId") || this.documentId;
	}

	cancelNextLoad() {
		this.$timeout.cancel(this.loadPromise);
	}

	nextLoad() {
		//Always make sure the last timeout is cleared before starting a new one
		this.cancelNextLoad();
		this.loadPromise = this.$timeout(
			this.awaitDocuments.bind(this),
			this.loadTime,
		);
	}

	setBeforeUnloadEvent() {
		this.$translate("app.finish.confirmationMessage").then((text) => {
			const onbefore = (event) => {
				if (this.pdfDownloaded) {
					return;
				}
				(event || this.$window.event).returnValue = text;
				return text;
			};

			this.$window.onbeforeunload = onbefore.bind(this);
			this.$window.addEventListener("beforeunload", onbefore.bind(this));
		});
	}

	downloadLetter() {
		this.pdfDownloaded = true;
		let url = `${this.api}/letters/${this.documentId}?jwt=${this.documentToken}`;
		return this.finishService.downloadLetter(url);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/finish/finish.controller.js